import { userHttp, noTokenHttp } from "@/api/config.js";

let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

export const UserInfoApi = () => {
  return userHttp.get(`users/${cookies["user-id"]}`);
};

export const ClassInfoApi = () => {
  return userHttp.get(`classes/${cookies["user-id"]}/classes?type=0`);
};

export const TimeApi = () => {
  return noTokenHttp.get(`tools/sys-time`);
};

export const HistoryClassInfoApi = () => {
  return userHttp.get(`classes/${cookies["user-id"]}/classes?type=1`);
};
